const PIXEL_ID = '989647247572489'

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  // Meta Pixel base code
  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  f.fbq('init', PIXEL_ID)

  initialized = true
}

export function trackPageView() {
  const f = window as any
  if (f.fbq) {
    f.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  const f = window as any
  if (f.fbq) {
    f.fbq('track', 'AddToCart', {
      content_name: 'Finanzas Sin Excusas eBook',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
